<template>
  <div id="home">
    <img style="width: 100px; height: 100px" alt="" src="@/assets/logo.png">
    <div></div>
    <el-button @click="buttonAgreementClick">用户协议</el-button>
    <el-button @click="buttonInvitationClick">邀请页</el-button>
    <el-button @click="buttonHomeClick">播放页面</el-button>
    <div></div>
    <HelloWorld :msg="msg"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  data() {
    return {
      msg: "Welcome to Your Vue.js Apppp"
    }
  },
  methods: {
    pageResponse(jstring) {
      console.log(jstring)
      // this.msg = jstring
    },
    buttonAgreementClick() {
      this.$router.push({path: '/agreement', query: {
        //
      }})
    },
    buttonInvitationClick() {
      this.$router.push({path: '/invitation', query: {
        code: '24904845',
      }})
    },
    buttonHomeClick() {
      this.$router.push({path: '/player', query: {
        videoId: '13109',
      }})
    },
  },
  components: {
    HelloWorld
  },
  mounted() {
    console.log('Home mounted')
  }
}
</script>

<style lang="scss" scoped>
  .match-parent {
    width: 100%;
  }
  /deep/.el-button:hover {
      color: #606266;
      border-color: #DCDFE6;
      background-color: #ffffff;
  }
</style>
